import React from "react";
import MDTypography from "components/MDTypography";

export default function CTLDateStatus({ value }) {
  if (value === null || value === 0) {
    return null;
  }

  let d = new Date(0);
  if (value?.toString().length === 10) {
    d.setUTCSeconds(value); 
  } else {
    d.setTime(value); 
  }

 
  const now = new Date();
  const timeDiff = Math.floor((now - d) / (1000 * 60)); 
  let statusColor;
  if (timeDiff <= 5) {
    statusColor = "green";
  } else if (timeDiff <= 10) {
    statusColor = "yellow";
  } else if (timeDiff <= 15) {
    statusColor = "orange";
  } else {
    statusColor = "red";
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          width: "25px",
          height: "25px",
          borderRadius: "50%",
          border: "2px solid white",
          backgroundColor: statusColor,
          marginRight: "8px",
        }}
      ></div>
      <MDTypography variant="caption1" fontWeight="medium" color="text">
        {d.toLocaleString()}
      </MDTypography>
    </div>
  );
}

CTLDateStatus.defaultProps = {
  suffix: "",
};
